import React from "react";
import { Route, Switch } from "react-router";
import AuthRoute from "../auth/components/routes/AuthRoute";
import { UserRole } from "../user/enums/UserRole";
import NotFound from "../pages/NotFound";
import { BroadcastPage } from "./pages/BroadcastPage";

export function Broadcast({ path }: { path: string }) {
  return (
    <Route path={path}>
      <Switch>
        <AuthRoute
          exact
          path={path}
          roles={[UserRole.Owner, UserRole.Admin]}
          component={BroadcastPage}
        />
        <Route path={`${path}/*`} component={NotFound} />
      </Switch>
    </Route>
  );
}
